import { NavMenuKeys } from '@/routes/navMenu';
import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { type Route } from '@/routes/route';

const { Page } = lazyImport(() => import('../index'), 'Page');
// 该页面的路由，以及所属那个模块
export const routes: Route[] = [
  {
    name: '工作台',
    path: '/dashboard/workspace',
    element: <Page />,
    module: NavMenuKeys.Dashboard,
    enable: true,
  },
];
